import { SelectionMap } from '@api/selections';

/**
 * See BackgroundColorSelectionfactory
 */
export type BackgroundColor = 'black' | 'transparent' | 'white';

const map: SelectionMap<BackgroundColor> = {
  black: 'bg-black',
  transparent: 'bg-transparent',
  white: 'bg-white',
};

export const getBackgroundColor = (color: BackgroundColor) => {
  const value = map[color];
  if (!value) {
    console.warn('No value for ', color);
  }
  return value;
};
